import portal from "@vacancorp/portal";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import i18n from "@/i18n";

type T =
  | PortalAdapterApi.ResponseGetPlaceDetail
  | portal.PublicPlaceWithVacancyId
  | PortalAdapterApi.ResponseGetPublicPlace;
type S = PortalAdapterApi.ResponseGetMergedDisplayVacancy;

export function setUnknownDisplayTextOnVacancy404(sortedPlaceList: T[]): S[] {
  return sortedPlaceList.map((place: T) => {
    return {
      placeIdHash: place.placeIdHash,
      status: "unknown",
      statusOrder: 9000,
      displayVacancyText: i18n.t("CongestionStatus.unknown").toString(),
      isShowCountText: false,
    };
  });
}
// 個数がマッチしない ( places: a,b,c ; vacancy: a を取る場合)と内容マッチしない ( places: a,b,c ; vacancy: a,d,e )
// and refill with the same indexes
export function refillVacancyListOnContentError(vacancyList: S[], sortedPlaceList: T[]): S[] {
  return sortedPlaceList.map((place) => {
    const matched: S | undefined = vacancyList.find(
      (vacancy) => place !== undefined && vacancy.placeIdHash === place.placeIdHash,
    );

    return matched
      ? matched
      : {
          placeIdHash: place ? place.placeIdHash : "",
          status: "unknown",
          statusOrder: 9000,
          displayVacancyText: i18n.t("CongestionStatus.unknown").toString(),
          isShowCountText: false,
        };
  });
}

/** @remarks vacancy display text */
export function getShortDisplayText(vacancyStatus: string, vacancyText: string): string {
  if (vacancyText === "" || vacancyStatus !== "waiting") return "";
  // only for waiting
  const roundedNumber: string = getVacancyWaitingNumber(vacancyText);
  return roundedNumber;
}
function getVacancyWaitingNumber(text: string): string {
  const numberOnly: RegExpMatchArray | null = text.match(/\d+/i);
  return numberOnly === null ? "" : numberOnly[0];
}
function $_enlargeVacancyWaitingNumber(vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy): string {
  const numberOnly: RegExpMatchArray | null = vacancyStatus.displayVacancyText.match(/\d+/i);
  return numberOnly === null ? "" : numberOnly[0];
}
function $_enlargeVacancyWaitingWords(vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy): string {
  const wordOnly: string | null = vacancyStatus.displayVacancyText.replace(/\d+/g, "");
  return wordOnly === null ? "" : wordOnly;
}
export function showVacancyText(vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined): string {
  if (vacancyStatus === undefined) return "";
  return vacancyStatus.status === "waiting"
    ? `<span style='font-size:20px;font-weight: 700;'>${$_enlargeVacancyWaitingNumber(vacancyStatus)}</span>
    <span style='font-size:15px;font-weight: 700;'>${$_enlargeVacancyWaitingWords(vacancyStatus)}</span>`
    : vacancyStatus.displayVacancyText;
}
export function showVacancyTextOnDetailPage(
  vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined,
): string {
  if (vacancyStatus === undefined) return "";
  return vacancyStatus.displayVacancyText;
}
export function showGreenFont(vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined): boolean {
  if (vacancyStatus === undefined) return false;
  return vacancyStatus.status === "vacancy" || vacancyStatus.status === "open" ? true : false;
}
export function showOrangeFont(vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined): boolean {
  if (vacancyStatus === undefined) return false;
  return vacancyStatus.status === "crowded" ? true : false;
}
export function showGrayFont(vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined): boolean {
  if (vacancyStatus === undefined) return false;
  return (
    vacancyStatus.status === "lo" ||
    vacancyStatus.status === "closed" ||
    vacancyStatus.status === "maintenance" ||
    vacancyStatus.status === "unknown" ||
    vacancyStatus.status === "notReady" ||
    vacancyStatus.status === "disabled"
  );
}
export function showPinkFont(vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined): boolean {
  if (vacancyStatus === undefined) return false;
  return vacancyStatus.status === "busy" ||
    vacancyStatus.status === "waiting" ||
    vacancyStatus.status === "full" ||
    vacancyStatus.status === "entryRestricted"
    ? true
    : false;
}

export function isHideVacancyCountText(
  vacancyStatus: PortalAdapterApi.ResponseGetMergedDisplayVacancy | undefined,
): boolean {
  if (vacancyStatus === undefined) return true;
  return (
    vacancyStatus.status === "closed" ||
    vacancyStatus.status === "unknown" ||
    vacancyStatus.status === "maintenance" ||
    vacancyStatus.status === "notReady" ||
    vacancyStatus.status === "waitingForServe" ||
    vacancyStatus.status === "backSoon" ||
    vacancyStatus.status === "disabled"
  );
}
